/**
 * P FS Bar — thanh Flash Sale mỏng trên đầu trang.
 *
 * Đọc trạng thái Flash Sale qua window.PPromo (assets/p-promo-core.js) — cùng
 * nguồn và cùng ngưỡng "hiện sớm N giờ" với section P Flash Sale, nên hai chỗ
 * không bao giờ nói lệch nhau.
 *
 * Khi có đợt FS:
 *   - bỏ `hidden` cho thanh, gắn class p-fs-bar-on lên <html> để ẩn thanh chữ
 *     chạy của theme;
 *   - trước khi ẩn thì ĐO chiều cao thanh chữ chạy và ghi vào --p-fsbar-h, nên
 *     đổi thanh không xô layout dù sau này đổi padding bên kia;
 *   - link trỏ tới collection mà đợt FS đang nhắm.
 *
 * Chớp trạng thái ở lượt tải đầu: dữ liệu BOGOS về sau khi trang đã vẽ. Lưu
 * trạng thái vào sessionStorage để từ trang thứ 2 trong phiên thanh hiện ngay
 * từ khung hình đầu, rồi đối chiếu lại khi PPromo sẵn sàng.
 *
 * Không dùng requestAnimationFrame (ngừng chạy khi tab không compositing).
 */
(function () {
  'use strict';
  if (window.__pFsBarInit) return;
  window.__pFsBarInit = true;

  var LABEL_RUNNING = 'Kết thúc sau';
  var LABEL_UPCOMING = 'Bắt đầu sau';
  var CACHE_KEY = 'p_fs_bar';
  var CACHE_MAX_AGE = 6 * 3600000; // 6h — quá hạn thì không tin nữa

  var SCROLLING_TEXT_SEL = '.shopify-section-group-header-group.js-section__scrolling-text';

  var _stop = null;

  function bars() { return document.querySelectorAll('[data-p-fs-bar]'); }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function num(el, attr) { return Number(el.getAttribute(attr)) || 0; }

  /* ------------------------------------------------------------------ *
   * Chiều cao: bám theo thanh chữ chạy đang có
   * ------------------------------------------------------------------ */

  function syncHeight() {
    var st = document.querySelector(SCROLLING_TEXT_SEL);
    if (!st) return;
    // Phải đo TRƯỚC khi ẩn, lúc ẩn rồi offsetHeight = 0.
    var h = st.offsetHeight;
    if (h > 0) {
      document.documentElement.style.setProperty('--p-fsbar-h', h + 'px');
    }
  }

  /* ------------------------------------------------------------------ *
   * Bật / tắt thanh
   * ------------------------------------------------------------------ */

  /**
   * Đổ chữ cho CẢ hai ô (câu dài desktop + câu ngắn mobile). CSS chọn ô nào
   * hiện theo bề ngang, JS không cần nghe sự kiện resize để đổi chữ.
   */
  function setMessages(bar, state) {
    var base = state === 'upcoming' ? 'data-msg-upcoming' : 'data-msg-running';
    var els = bar.querySelectorAll('[data-p-fs-msg]');
    for (var i = 0; i < els.length; i++) {
      var attr = els[i].getAttribute('data-variant') === 'short' ? base + '-short' : base;
      var txt = bar.getAttribute(attr);
      if (txt) els[i].textContent = txt;
    }
  }

  function applyState(bar, state, href) {
    if (bar.getAttribute('data-hide-scrolling-text') === '1') {
      syncHeight();
      document.documentElement.classList.add('p-fs-bar-on');
    }

    var lbl = bar.querySelector('[data-p-fs-label]');
    if (lbl) lbl.textContent = state === 'upcoming' ? LABEL_UPCOMING : LABEL_RUNNING;
    setMessages(bar, state);
    if (href) bar.setAttribute('href', href);

    bar.hidden = false;
  }

  function show(bar, state, target, href) {
    applyState(bar, state, href);
    startClock(bar, target);
  }

  function hide(bar) {
    bar.hidden = true;
    document.documentElement.classList.remove('p-fs-bar-on');
    stopClock();
  }

  function stopClock() {
    if (_stop) { try { _stop(); } catch (e) {} }
    _stop = null;
  }

  function startClock(bar, target) {
    stopClock();
    var p = window.PPromo;
    var hh = bar.querySelector('[data-p-fs-hh]');
    var mm = bar.querySelector('[data-p-fs-mm]');
    var ss = bar.querySelector('[data-p-fs-ss]');
    if (!hh || !p || !target) return;

    _stop = p.countdown(target, function (t) {
      // Không có ô "ngày" — dồn hết vào giờ, giống khối P Flash Sale.
      hh.textContent = pad2(t.hours + t.days * 24);
      if (mm) mm.textContent = pad2(t.minutes);
      if (ss) ss.textContent = pad2(t.seconds);
      if (t.done) setTimeout(refresh, 1200); // hết đợt -> tính lại trạng thái
    });
  }

  /* ------------------------------------------------------------------ *
   * Bộ nhớ phiên — khử chớp ở lượt tải sau
   * ------------------------------------------------------------------ */

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      var now = Date.now();
      if (!c || !c.target || !c.savedAt) return null;
      if (now - c.savedAt > CACHE_MAX_AGE) return null;
      if (c.target <= now + 5000) return null; // sắp hết -> đừng đoán
      return c;
    } catch (e) { return null; }
  }

  /* Không lưu câu chữ vào cache — chữ luôn đọc từ attribute của section, để
     sửa text trong Theme Editor là ăn ngay, không dính bản cũ trong phiên. */
  function writeCache(state, target, href) {
    try {
      sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ state: state, target: target, href: href, savedAt: Date.now() })
      );
    } catch (e) {}
  }

  function clearCache() {
    try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
  }

  /* ------------------------------------------------------------------ *
   * Trạng thái thật từ PPromo
   * ------------------------------------------------------------------ */

  function pickSale(bar) {
    var p = window.PPromo;
    if (!p || !p.getFlashSales) return null;

    var hours = num(bar, 'data-upcoming-hours') || 3;
    var list = p.getFlashSales({
      includeUpcoming: true,
      upcomingWithinMs: hours * 3600000
    }) || [];

    var showUpcoming = bar.getAttribute('data-show-upcoming') === '1';

    for (var i = 0; i < list.length; i++) {
      var d = list[i];
      if (d.state === 'running') return d;
      if (d.state === 'upcoming' && showUpcoming) return d;
    }
    return null;
  }

  function saleHref(bar, sale) {
    var handles = (sale && sale.collectionHandles) || [];
    if (handles.length) return '/collections/' + handles[0];
    return bar.getAttribute('data-fallback-link') || null;
  }

  function refresh() {
    var list = bars();
    for (var i = 0; i < list.length; i++) {
      var bar = list[i];
      var sale = pickSale(bar);

      if (!sale) {
        hide(bar);
        clearCache();
        continue;
      }

      var target = sale.state === 'upcoming' ? sale.startsAt : sale.endsAt;
      var href = saleHref(bar, sale);

      show(bar, sale.state, target, href);
      writeCache(sale.state, +new Date(target), href);
    }
  }

  /* ------------------------------------------------------------------ *
   * Khởi động
   * ------------------------------------------------------------------ */

  function paintFromCache() {
    var c = readCache();
    if (!c) return;
    var list = bars();
    for (var i = 0; i < list.length; i++) {
      // Vẽ lạc quan: chưa có PPromo nên chưa chạy đồng hồ, chỉ dựng đúng
      // khung + chữ để không chớp. refresh() chỉnh lại ngay sau đó.
      applyState(list[i], c.state, c.href);
    }
  }

  /**
   * Đổi bề ngang cửa sổ thì chiều cao thanh chữ chạy cũng đổi (49px desktop /
   * 43px mobile). Nó đang bị display:none nên đo được 0 — phải bỏ ẩn, đo, ẩn
   * lại. Cả ba việc nằm trong CÙNG một tác vụ JS nên trình duyệt không paint
   * xen vào giữa, người dùng không thấy nhấp nháy.
   */
  function remeasure() {
    var root = document.documentElement;
    if (!root.classList.contains('p-fs-bar-on')) { syncHeight(); return; }
    root.classList.remove('p-fs-bar-on');
    syncHeight();
    root.classList.add('p-fs-bar-on');
  }

  function start() {
    if (!bars().length) return;

    syncHeight();
    paintFromCache();

    var rz;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(remeasure, 200);
    });

    if (window.PPromo) {
      window.PPromo.ready(refresh);
      window.PPromo.onChange(refresh);
      return;
    }

    // p-promo-core.js nạp defer — chờ bằng setTimeout, không dùng rAF.
    var tries = 40;
    (function wait() {
      if (window.PPromo) { start(); return; }
      if (tries-- <= 0) return;
      setTimeout(wait, 150);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
